import { render, staticRenderFns } from "./FilesFilters.vue?vue&type=template&id=c0e9313e&"
import script from "./FilesFilters.vue?vue&type=script&lang=js&"
export * from "./FilesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0e9313e')) {
      api.createRecord('c0e9313e', component.options)
    } else {
      api.reload('c0e9313e', component.options)
    }
    module.hot.accept("./FilesFilters.vue?vue&type=template&id=c0e9313e&", function () {
      api.rerender('c0e9313e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/docDigital/components/FilesFilters.vue"
export default component.exports